import type { SVGProps } from 'react';

const QR = (props?: SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.25 19.25H6.75C5.64543 19.25 4.75 18.3546 4.75 17.25V16.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.75 12.75H8.25C9.35457 12.75 10.25 13.6454 10.25 14.75V16.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.25 14.75H15.75C15.1977 14.75 14.75 15.1977 14.75 15.75V18.25C14.75 18.8023 15.1977 19.25 15.75 19.25H18.25C18.8023 19.25 19.25 18.8023 19.25 18.25V15.75C19.25 15.1977 18.8023 14.75 18.25 14.75Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.75 11.25H19.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.75 7.75H15.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.75 4.75H17.25C18.3546 4.75 19.25 5.64543 19.25 6.75V8.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.25 4.75H5.75C5.19772 4.75 4.75 5.19772 4.75 5.75V8.25C4.75 8.80228 5.19772 9.25 5.75 9.25H8.25C8.80228 9.25 9.25 8.80228 9.25 8.25V5.75C9.25 5.19772 8.80228 4.75 8.25 4.75Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default QR;
